import React, { useEffect, useRef, useState } from 'react'
import classNames from 'classnames'
import { Icon } from 'meinian-package/src/component'
import styles from './index.module.less'

export default ({
  options,
  value = null,
  label = 'label',
  allowClear = true,
  allowClearText = '不限',
  onChange,
  children = undefined,
  style = undefined,
  className = undefined,
}) => {
  const [hiddenUnfold, setHiddenUnfold] = useState(false)
  const [isUnfold, setIsUnfold] = useState(true)
  const innerNode = useRef(null)
  const outerNode = useRef(null)

  useEffect(() => {
    const innerLayerWidth = innerNode.current?.getBoundingClientRect().width
    const outerNodeLayerWidth = outerNode.current?.getBoundingClientRect().width
    if (innerLayerWidth >= outerNodeLayerWidth) {
      setHiddenUnfold(true)
    } else {
      setHiddenUnfold(false)
    }
  }, [options, innerNode.current, outerNode.current])

  const [innerHeight, setInnerHeight] = useState(40)

  useEffect(() => {
    const config = { attributes: true, childList: true, subtree: true }
    const callback = () => {
      const height = innerNode.current?.clientHeight
      if (isUnfold) {
        setInnerHeight(height)
      } else {
        setInnerHeight(40)
      }
    }
    callback()
    const observer = new MutationObserver(callback)
    observer.observe(innerNode.current, config)
    return () => {
      observer.disconnect()
    }
  }, [innerNode.current, isUnfold, hiddenUnfold])

  return (
    <div className={classNames(styles.tiledSelect, className)} style={style}>
      <div className="tiledSelect-line-label">{label}</div>
      {children}
      <div className="tiledSelect-line-wrap">
        <div className="tiledSelect-line-value" ref={outerNode} style={{ height: innerHeight }}>
          <div className="tiledSelect-line-value-wrap-node" ref={innerNode}>
            {allowClear && (
              <div
                className={classNames('tiledSelect-line-value-item', { active: value === null })}
                onClick={() => onChange(null, {})}
              >
                {allowClearText}
              </div>
            )}
            {options.map((item) => (
              <div
                className={classNames('tiledSelect-line-value-item', { active: value === item.value })}
                onClick={() => onChange(item.value, item)}
              >
                {item.label}
              </div>
            ))}
          </div>
        </div>
        {hiddenUnfold && (
          <div className="tiledSelect-line-wrap-unfold" onClick={() => setIsUnfold((pre) => !pre)}>
            {!isUnfold ? '展开' : '收起'}
            <Icon
              type="m-Vxing_xia"
              className="tiledSelect-line-wrap-unfold-icon"
              style={{ transform: !isUnfold ? 'rotate(180deg)' : undefined, transition: 'all 0.3s' }}
            />
          </div>
        )}
      </div>
    </div>
  )
}
